module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты " + _vm._s(_vm.id))]), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap recipes-wrap__single"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn-back",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaBack($event)
      }
    }
  }, [_c('Arrow'), _vm._v("Вернуться")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem.name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem.portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem.time))])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.RecipeItem.image,
      "alt": "Recipe Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recipe-block"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n                    Ингридиенты:\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.RecipeItem.ingredients), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "name left"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "value right"
    }, [_vm._v(_vm._s(item.value))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-block"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n                    Инструкция приготовления:\n                ")]), _vm._v(" "), _c('ol', {
    staticClass: "instruction"
  }, _vm._l((_vm.RecipeItem.instruction), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn-back mobile-hidden",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaBack($event)
      }
    }
  }, [_c('Arrow'), _vm._v("Вернуться")], 1), _vm._v(" "), _c('a', {
    staticClass: "btn-top desktop-hidden",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTop($event)
      }
    }
  }, [_c('span', [_vm._v("В начало")]), _c('Arrow')], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c4d94b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/RecipeItem.vue
// module id = 99
// module chunks = 0